import React from 'react';
import styled from 'styled-components';
import {Icon} from '../../ui-toolkit/elements/Icon/Icon';
import {FormLabel} from '../../ui-toolkit/forms/form-features/labels/FormLabel';
import {colorTheme} from '../../ui-toolkit/mixin/colorTheme';

const CheckUncheckLabel = ({children, disabled, checked, htmlFor}) => (
    <CheckUncheckLabelContainer disabled={disabled} checked={checked} htmlFor={htmlFor}>
        <FormSelectionBox>
            <BoxContainer>
                <Icon name="Check" />
            </BoxContainer>
        </FormSelectionBox>

        <FormLabel disabled={disabled} htmlFor={htmlFor}>
            {' '}
            {children}{' '}
        </FormLabel>
    </CheckUncheckLabelContainer>
);

export const FormSelectionBox = styled.div`
    flex-shrink: 0;
    width: var(--box-size);
    height: var(--box-size);
    position: relative;
    margin-right: 4px;
    padding: 0;
    display: inline-block;
    transition: 0.2s;
`;

const BoxContainer = styled.div`
    position: absolute;
    top: calc(50% - 0.5px);
    left: 50%;
    transform: translate(-50%, -50%);
    ${Icon.Wrapper} {
        line-height: 0 !important;
        width: var(--box-size) !important;
        height: var(--box-size) !important;
        display: block;
        svg {
            width: var(--box-size) !important;
            height: var(--box-size) !important;
        }
    }
`;

const CheckUncheckLabelContainer = styled.label`
    --box-size: 14px;
    display: inline-flex !important;
    align-items: center;
    font-weight: 400;
    margin-bottom: 0;
    ${colorTheme({
        '--checkbox-checked-color     ': {dark: 'var(--label-text-color)  ', light: 'var(--primary)'},
    })};

    ${FormSelectionBox},
    ${FormLabel} {
        cursor: pointer;
    }
    &:hover ${FormLabel} {
        color: var(--primary);
    }
    &:active {
        ${FormSelectionBox} {
            transform: scale(0.8);
        }
    }
    pre {
        margin: 0;
    }

    ${({disabled}) => {
        if (disabled)
            return `
            * {
                cursor: not-allowed!important;
            }
            &:hover ${FormLabel},
            ${FormLabel}{
                opacity: 0.5!important;
                color: var(--label-text-color)!important;
            }
            ${FormSelectionBox} {
                border-color: var(--container-text-color-disabled-100) !important;
                opacity: 0.5;
            }
        `;
        else return ``;
    }}
`;

export const selectSetup = () => `
    input[type="checkbox"]:checked+label,
    input[type="radio"]:checked+label{
        ${FormSelectionBox} {
            background: var(--checkbox-checked-color);
            border: 1px solid var(--checkbox-checked-color);
           svg {
                color: var(--white-00);
           }
        }
    }

    input[type="checkbox"]+label,
    input[type="radio"]+label{
        ${FormSelectionBox} {
            background: var(--app-background);
            border: 1px solid var(--label-text-color);
            svg {
                color: var(--app-background);
            }
        }
    }

    input[type="checkbox"]+label{
        ${FormSelectionBox} {
           border-radius: 2px;
        }
    }
    input[type="radio"]+label{
        ${FormSelectionBox} {
           border-radius: 50%;
        }
    }
    
    input[disabled]+label,
    input[disabled]:checked+label{
        ${FormSelectionBox} {
            transform: scale(1);
        }
        cursor: not-allowed!important;
    }
    
    input:focus-visible[type="checkbox"]+label,
    input:focus-visible[type="radio"]+label{
            color: var(--primary);
        ${FormSelectionBox} {
            outline-color:var(--primary);
            outline-style: solid;
            outline-offset: 1px;
        }
    }
`;

const CheckboxLabel = styled(CheckUncheckLabel)`
    ${FormSelectionBox} {
        border-radius: 2px !important;
        display: none;
    }
`;
const RadioLabel = styled(CheckUncheckLabel)`
    ${FormSelectionBox} {
        border-radius: 50% !important;
        display: none;
    }
`;

export {RadioLabel, CheckboxLabel, CheckUncheckLabel, CheckUncheckLabelContainer};
